import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "@progress/kendo-react-buttons";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Alert, FormMaskedTextBox } from "@mikros/shared-ui";
import ApiServices from "../../service/apiService";
import {
  Grid,
  GridColumn,
  GridNoRecords,
  GridPageChangeEvent,
  GridSelectionChangeEvent,
} from "@progress/kendo-react-grid";
import React, { useEffect, useState } from "react";
import { TextBoxProps } from "@progress/kendo-react-inputs";
import {
  PagerTargetEvent,
  getSelectedState,
} from "@progress/kendo-react-data-tools";
import { getter } from "@progress/kendo-react-common";
import { InfinitySpin } from "react-loader-spinner";

import ErrorHandler from "../../utils/errorConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useNavigate } from "react-router-dom";

export interface ShareCourseCustProps {
  targetAccountIdFunction: Function;
}

export function ShareCourseCustomerSearch(props: ShareCourseCustProps) {
  interface PageState {
    skip: number;
    take: number;
  }

  const intl = useIntl();
  const errorInstance = ErrorHandler.getErrorInstance();
  const navigate = useNavigate();

  const initialDataState: PageState = {
    skip: 0,
    take: 10,
  };
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  const [selectedState, setSelectedState] = React.useState<{
    [id: string]: boolean | number[];
  }>({});
  const [loader, setLoader] = React.useState<boolean>(false);
  const [searchClicked, setSearchClicked] = React.useState<boolean>(false);

  console.log("loader value in search customer", loader);

  console.log("selected state print", selectedState);

  const nameRegex = new RegExp(/^$|[a-zA-Z\s. ]+$/);
  const emailRegex: RegExp = new RegExp(/^$|^.*@.*\..*$/);
  const legalNameRegex = new RegExp(/^$|[a-zA-Z\s. ]+$/);
  const mobileRegex: RegExp = new RegExp(/^$|[0-9]{5,15}$/);
  const validators = {
    custNameValidator: (value: string) =>
      nameRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "shareCustomer.customerNameValidation",
          })}`,
    emailValidator: (value: string) =>
      value
        ? emailRegex.test(value)
          ? ""
          : `${intl.formatMessage({
              id: "shareCustomer.emailValidation",
            })}`
        : "",
    legalNameValidator: (value: string) =>
      legalNameRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "shareCustomer.leagalNameValidation",
          })}`,
    mobileNumberValidator: (value: string) =>
      value
        ? mobileRegex.test(value)
          ? ""
          : `${intl.formatMessage({
              id: "shareCustomer.mobileNumberValidation",
            })}`
        : "",
  };
  const [formKey, setFormKey] = React.useState(1);
  const [customerData, setCustomerData] = React.useState<any>([]);
  const [value, setValue] = React.useState<TextBoxProps["value"]>(" ");

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  const DATA_ITEM_KEY = "accntId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  console.log("print data item key", DATA_ITEM_KEY);

  async function searchCustomer(formData: { [name: string]: any }) {
    // setLoader(true);

    console.log("search customer data for share", formData);
    console.log("mobile number in search cust data", formData["mobileno"]);

    const hasValidInput = Object.values(formData).some(
      (value) => typeof value === "string" && value.trim() !== ""
    );
    if (!hasValidInput) {
      console.log("No search fields filled. Skipping API call.");
      return; //  Skip API call if all fields are empty
    }

    setSearchClicked(true);
    setLoader(true);

    let queryString = "";
    if (formData["mobileno"]) {
      if (queryString === "") {
        queryString = "phNo" + "=" + formData["mobileno"];
      } else {
        queryString = queryString + "&" + "phNo" + "=" + formData["mobileno"];
      }
      console.log("query string mobile print", queryString);
    }
    if (formData["custName"]) {
      if (queryString === "") {
        queryString = "custName" + "=" + formData["custName"];
      } else {
        queryString =
          queryString + "&" + "custName" + "=" + formData["custName"];
      }
    }

    if (formData["legalName"]) {
      if (queryString === "") {
        queryString = "legalName" + "=" + formData["legalName"];
      } else {
        queryString =
          queryString + "&" + "legalName" + "=" + formData["legalName"];
      }
    }

    if (formData["email"]) {
      if (queryString === "") {
        queryString = "email" + "=" + formData["email"];
      } else {
        queryString = queryString + "&" + "email" + "=" + formData["email"];
      }
    }

    console.log("query string befor api call", queryString);
    let api = ApiServices.getInstance();
    api
      .makeRequest(`organization/filteruser?${queryString}`, "GET")
      .then(async (data) => {
        if (data && data.errorMessage) {
          setErrorFlag(true);
          await errorInstance.updateErrorCode(data.errorMessage);
          return;
        }
        console.log("filter user customer data", data);
        setCustomerData(data);
      })
      .catch((error) => {
        console.error("error fetching customer data", error);
      })
      .finally(() => {
        setLoader(false);
      });
  }
  const clearSearch = () => {
    setFormKey(formKey + 1);
    if (searchClicked) {
      setLoader(true);
      let api = ApiServices.getInstance();
      api
        .makeRequest("organization", "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }
          console.log("clear customer search", data);
          setCustomerData(data);
        })
        .finally(() => setLoader(false));
      setSearchClicked(false);
    }
  };

  const onSelectionChange = (event: GridSelectionChangeEvent) => {
    props.targetAccountIdFunction(event.dataItem.accntId);
    const newSelectedState = getSelectedState({
      event,
      selectedState: selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });
    setSelectedState(newSelectedState);
    console.log("newly selected state: " + newSelectedState);
    console.log("selected state after selection", selectedState);
  };

  const headerCellRender = (td: any, props: any) => {
    if (props.field == SELECTED_FIELD) {
      return <td {...td.props}></td>;
    }
    return td;
  };
  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    //@ts-ignore
    const take =
      targetEvent.value === "All" ? customerData.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  useEffect(() => {
    setLoader(true);
    let api = ApiServices.getInstance();
    api
      .makeRequest("organization", "GET")
      .then(async (data) => {
        if (data && data.errorMessage) {
          setErrorFlag(true);
          await errorInstance.updateErrorCode(data.errorMessage);
          return;
        }
        console.log("print customer data in search customer", data);
        setCustomerData(data);
      })
      .finally(() => {
        setLoader(false);
      });
  }, []);

  return (
    <div className="">
      {loader && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 z-20">
          <div>
            <div className="w-full h-full bg-transparent loader"></div>
            <div className="absolute top-1/3 left-1/2">
              <InfinitySpin
                width="200"
                color="var(--color-mk-primary-bright)"
              />
            </div>
          </div>
        </div>
      )}

      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              navigate("/courses");
            }}
          />
        </Dialog>
      )}

      <div className="flex items-end justify-between">
        {/* <div className="text-mk-primary-bright text-2xl mt-8 font-semibold"> */}
        <div className="text-mk-primary-bright text-2xl font-semibold">
          <FormattedMessage id="shareCourseCustomerSearch.searchCustomer" />
        </div>
      </div>

      <div className="mt-2">
        <Form
          onSubmit={searchCustomer}
          key={formKey}
          render={(formRenderProps) => (
            <FormElement>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div>
                    <Field
                      name={"custName"}
                      id={"custName"}
                      label={
                        <FormattedMessage id="searchCustomer.customerName" />
                      }
                      value={value}
                      component={FormMaskedTextBox}
                      validator={validators.custNameValidator}
                      onChange={(e: any) => {
                        const inputValue = e.value;
                      }}
                      className="bg-white w-72"
                      maxLength={20}
                    />
                  </div>
                </div>
                <div>
                  <Field
                    name={"email"}
                    id={"email"}
                    label={<FormattedMessage id="searchCustomer.EmailId" />}
                    maxLength={60}
                    component={FormMaskedTextBox}
                    className="bg-white w-72"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div>
                    <Field
                      name={"legalName"}
                      id={"legalName"}
                      label={<FormattedMessage id="searchCustomer.LegalName" />}
                      value={value}
                      validator={validators.legalNameValidator}
                      component={FormMaskedTextBox}
                      onChange={(e: any) => {
                        const inputValue = e.value;
                      }}
                      className="bg-white w-72"
                      maxLength={20}
                    />
                  </div>
                </div>
                <div>
                  <Field
                    name={"mobileno"}
                    id={"mobileno"}
                    label={
                      <FormattedMessage id="searchCustomer.MobileNumber" />
                    }
                    maxLength={20}
                    component={FormMaskedTextBox}
                    className="bg-white w-72"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div></div>
                <div className="mt-4">
                  <Button
                    className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                                        hover:text-black focus:outline-none px-4 py-2"
                  >
                    <FormattedMessage id="searchCustomer.Search" />
                  </Button>
                  &nbsp;
                  <Button
                    className="rounded-lg bg-mk-light-grey text-black hover:bg-mk-light-grey

                                        hover:text-black focus:outline-none px-4 py-2"
                    onClick={clearSearch}
                  >
                    <FormattedMessage id="searchCustomer.Clear" />
                  </Button>
                </div>
              </div>
            </FormElement>
          )}
        />
      </div>
      <div className="mt-6 hide-scroll bg-transparent max-w-full flex overflow-x-auto space-x-7 pb-8 px-4">
        <div className="text-mk-primary-bright">
          <Grid
            style={{ border: 0, backgroundColor: "transparent" }}
            rowHeight={48}
            headerCellRender={headerCellRender}
            data={customerData
              ?.slice(page.skip, page.take + page.skip)
              .map((item: any) => ({
                ...item,
                [SELECTED_FIELD]: selectedState[idGetter(item)],
              }))}
            skip={page.skip}
            take={page.take}
            total={customerData.length}
            pageable={{
              buttonCount: 4,
              pageSizes: [5, 10, 15, "All"],
              pageSizeValue: pageSizeValue,
            }}
            onPageChange={pageChange}
            onSelectionChange={onSelectionChange}
            selectedField={SELECTED_FIELD}
            className="cursor-pointer"
            selectable={{
              enabled: true,
              drag: true,
              mode: "single",
            }}
          >
            <GridColumn
              field={SELECTED_FIELD}
              headerSelectionValue={
                customerData
                  ?.slice(page.skip, page.take + page.skip)
                  .findIndex((item: any) => !selectedState[idGetter(item)]) ===
                -1
              }
              headerClassName="custom-header"
            />
            <GridNoRecords>
              <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                <FormattedMessage id="customer.noCustomer" />
              </div>
            </GridNoRecords>
            <GridColumn
              field="organizationName"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.customeGridName",
              })}
              headerClassName="custom-header"
              cell={(props) => <td>{props.dataItem?.organizationName}</td>}
            />
            <GridColumn
              field="legalName"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.LegalName",
              })}
              headerClassName="custom-header"
              cell={(props) => <td>{props.dataItem?.legalName}</td>}
            />
            <GridColumn
              field="email"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.EmailID",
              })}
              headerClassName="custom-header"
              cell={(props) => <td>{props.dataItem?.email}</td>}
            />
            <GridColumn
              field="phNo"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.MobileNumber",
              })}
              headerClassName="custom-header"
              cell={(props) => <td>{props.dataItem?.phNo}</td>}
            />
          </Grid>
        </div>
      </div>
    </div>
  );
}
